import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  constructor() {
  }

  // Verify field validators in each field
  formIsValid(truckForm: FormGroup): boolean {
    for (const key of Object.keys(truckForm.controls)) {
      if (truckForm.get(key)?.errors != null) {
        return false;
      }
    }

    return true;
  }

  // Verify a particular field validator
  fieldIsValid(truckForm: FormGroup, field: string): boolean {
    return truckForm.get(field)?.errors === null;
  }

  // Is called when the html tag finds a unsatisfied validator condition
  // Returns corresponding error message
  getErrorMessage(truckForm: FormGroup, fieldName: string): string {
    if (truckForm.get(fieldName)?.hasError('required')) {
      return 'Campo obligatorio';
    } else if (truckForm.get(fieldName)?.hasError('pattern') || truckForm.get(fieldName)?.hasError('max')) {
      return 'Formato inválido';
    }

    return 'Unexpected call';
  }
}
